import { atom, useSetAtom, useAtomValue } from 'jotai'
import { ModalObjectProps } from '../types'
import { useCallback, useMemo } from 'react'

export const modalsAtom = atom<ModalObjectProps[]>([])

export const useOpenModals = () => {
  return useAtomValue(modalsAtom)
}

export const useIsModalOpen = () => {
  const modals = useOpenModals()
  return useCallback(
    (id: string) => {
      return modals.some((modal) => modal.id === id)
    },
    [modals],
  )
}

export const useModals = () => {
  const setModals = useSetAtom(modalsAtom)
  const isModalOpen = useIsModalOpen()

  const openModal = useCallback(
    (id: string, context?: Record<string, any>) => {
      setModals((prev) => {
        if (prev.some((modal) => modal.id === id)) {
          return prev
        }
        return [...prev, { id, context }]
      })
    },
    [setModals],
  )

  const closeModal = useCallback(
    (id: string) => {
      setModals((prev) => prev.filter((modal) => modal.id !== id))
    },
    [setModals],
  )

  const clearModals = useCallback(() => {
    setModals([])
  }, [setModals])

  return useMemo(() => {
    return {
      openModal,
      closeModal,
      isModalOpen,
      clearModals,
    }
  }, [isModalOpen, openModal, closeModal, clearModals])
}
